var logoImage = "/static/20a4707d5cbe967c.png";

export { logoImage as default };
//# sourceMappingURL=logo-3d.png.js.map
